export default {"src":"/_next/static/media/verified-white.aa553e1a.svg","height":23,"width":22};